/**
 * Emailes megosztás komponens
 * @author Erik Banhalmi 201.06.28.
 */
export const shareInEmailComponent = {
	bindings: {
		shareResponse: '<',
		shareResponseError: '<',
		onShare: '&',
		type: '@',
		favourite: '<',
		comissionId: '<',
		analyticsPopupPageParam: '@'
	},
	templateUrl: 'share-in-email.html',
	controller: class shareInEmailComponent {
		constructor($mdDialog, CommonConstants, $timeout, vcRecaptchaService) {
			'ngInject';
			this.$mdDialog = $mdDialog;
			this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			this.model = {};
			this.showShareSuccess = false;
			this.CommonConstants = CommonConstants;
			this.vcRecaptchaService = vcRecaptchaService;
			this.$timeout = $timeout;
		}
		$onChanges(changes) {
			if (changes.shareResponse && !changes.shareResponse.isFirstChange()) {
				if (this.shareResponse == true) {
					this.showShareSuccess = true;
				}
			}
			if (changes.shareResponseError && !changes.shareResponseError.isFirstChange()) {
				if (this.shareResponseError == true) {
					this.showShareError = true;
				}
			}
			// Kedvencek oldal workaround kicsi gombra
			if (changes.type && this.type) {
				if (this.type == 'mini') {
					angular.element('.md-fab.btn-secondary.btn-secondary--green.m10-share__button.icon-mail').addClass('md-mini');
				}
			}
		}
		openMessageForm() {
			this.showShareSuccess = false;
			this.showShareError = false;
			let param = {
				event: 'sharePropertyLink',
				propertyID: this.comissionId
			};
			window.dataLayer.push(param);
			this.$mdDialog.show({
				templateUrl: 'share-in-email-popup.html',
				clickOutsideToClose: true,
				controller:()=>this,
				controllerAs: '$ctrl'
			}).finally(() => {
				window.dataLayer.push({
					event: 'propertyShareModalClose'
				});
				this.closeShareDialog();
			});
		}
		sendShare() {
			window.dataLayer.push({
				event: 'sendPropertyLink',
				propertyID: this.comissionId
			});
			this.vcRecaptchaService.execute(this.widgetId);
		}
		closeShareDialog(type) {
			this.$mdDialog.cancel();
			this.showShareSuccess = false;
			this.model = {};
			this.vcRecaptchaService.destroy(this.widgetId);
		}

		setResponse(response) {
			this.model.captcha = response;
			this.model.fav = this.favourite ? this.favourite : '';
			this.model.comissionId = this.comissionId ? this.comissionId : '';
			this.onShare({
				$event: {
					share: this.model
				}
			});
		}

		captchaExpired() {
			window.grecaptcha.reset(this.widgetId);
		}

		getWidgetId(widgetId) {
			this.widgetId = widgetId;
		}
	}
};
